import { EspecialUno } from '../../models/especial-uno';
import { EspecialUnoService } from '../../services/especial-uno.service';
import { IpPublicService } from '../../../../services/ip-public.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup, FormGroup } from '@angular/forms';
import { AlertService } from '../../../../services/alert.service';
import { ModalService } from '../../../../services/modal.service';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { ObjetivoService } from 'src/app/modulos/elementos-plan/services/objetivo.service';
import { ConfiguracionIndicadoresService } from 'src/app/modulos/elementos-plan/services/configuracion-indicadores.service';
import { EtapaService } from 'src/app/modulos/elementos-plan/services/etapa.service';
import { ProcesoService } from 'src/app/modulos/elementos-plan/services/proceso.service';

@Component({
  selector: 'app-especial-uno',
  templateUrl: './especial-uno.component.html',
  styleUrls: ['./especial-uno.component.css']
})
export class EspecialUnoComponent implements OnInit, OnDestroy {

  breadCrumbItems = [{ label: 'Administración Sistema' }, { label: 'Catálogos Proceso' }, { label: 'Especial Uno', active: true }];

  public mostrarModal: boolean = false;
  public dataViewTable!: any;
  public formEspecialUno!: UntypedFormGroup;
  public formSelectCatalogo!: FormGroup;
  public submitted = false;
  private currentUser!: any;


  private ipAddress!: string;
  private buffer!: any;
  public dataApp: any[] = [];
  private idDeleteRegister: number = 0;
  public selectItems: any[] = [];
  public nameUnidad!: any;
  fathers: any = [];
  publicpp!: any;

  selectedOptionRecursivo: any = null;
  filtroPost = ''; //para la clase filtro
  public nombrePadre: string = null; //para validacion de catalogo
  public nameModal: string = 'modalNewEdit'
  nameApp = 'CATÁLOGO ESPECIAL UNO';

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  isDtInitialized: boolean = false;

  constructor(
    private fb: FormBuilder,
    private especialUnoService: EspecialUnoService,
    private alert: AlertService,
    private ip: IpPublicService,
    private objetivosService: ObjetivoService,
    private etapaService: EtapaService,
    private procesoService: ProcesoService,
    private configIndicadorService: ConfiguracionIndicadoresService,
    public modal: ModalService

  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.selectItems = [
      { value: '', label: 'Seleccione' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];

  }

  get rolForm() {
    return this.formEspecialUno.controls;
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  setForm() {
    this.listDataApp();
    this.formEspecialUno = this.fb.group({
      idSprEspecialUno: [],
      spr_idSprEspecialUno: [],
      nombrePadre: [], // nombre de la validacion de un padre
      nombre: ['', [Validators.required]],
      descripcion: [''],
      ponderacion: ['', [Validators.required]],
      estado: ['', [Validators.required]],
    });
    this.formSelectCatalogo = this.fb.group({

      spr_idSprEspecialUno: [0],
    });
  }

  initApp() {
    this.listDataApp();
    this.setDataTable();
    this.setForm();
  }
  ngOnInit(): void {
    this.getIpPublic();
    this.initApp();
  }
  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }


  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  onSubmit() {
    this.submitted = true;

    this.formEspecialUno.value.usuario = this.currentUser.idSprUsuario;
    this.formEspecialUno.value.ip = this.ipAddress;
    this.formEspecialUno.value.nombre = this.formEspecialUno.value.nombre.trim().toUpperCase();
    this.selectedOptionRecursivo = this.formEspecialUno.value.spr_idSprEspecialUno;

    if (this.formEspecialUno.value.idSprEspecialUno == null) {
      //if (this.listEspecialUnoExiste(this.formEspecialUno.value.nombre)) {
        this.especialUnoService.create(this.formEspecialUno.value).subscribe(
          (resp) => {
            this.initApp();
            this.modal.close();
            this.alert.createOk();
          },
          (err) => {
            this.alert.createError();
          }
        );
      //}
    } else {
     // if (this.listEspecialUnoExisteDiferente(this.formEspecialUno.value.nombre, this.formEspecialUno.value.idSprEspecialUno)) { por revisar
      this.especialUnoService.update(this.formEspecialUno.value).subscribe(
        (resp) => {
          this.initApp();
          this.modal.close();
          this.alert.updateOk();
        },
        (err) => {
          this.alert.updateError();
        }
      );
    //}
    }
  }

  listEspecialUnoExiste(nombre: any) {
    // para que no se repita los nombres
    let nombresInicio = nombre.trimStart();
    let nombresFin = nombresInicio.trimEnd();
    for (let elemento of this.dataApp) {
      if (elemento.nombre == nombresFin) {
        this.alert.warning('¡Atención!',"Existe un catálogo especial uno con el mismo nombre");
        return false;
      }
    }
    return true;
  }

  listEspecialUnoExisteDiferente(nombre: any, idSprEspecialUno: any) {
    let vector: any = [];
    let vectorFiltrado: any = [];

    // para que no se repita los nombres
    let nombresInicio = nombre.trimStart();
    let nombresFin = nombresInicio.trimEnd();
    vector = this.dataApp;
    for (let elemento of vector) {
      if (elemento.idSprEspecialUno !== idSprEspecialUno) {
        vectorFiltrado.push(elemento);
      }
    }
    for (let elemento of vectorFiltrado) {
      if (elemento.nombre == nombresFin) {
        this.alert.warning('¡Atención!',"Existe un catálogo especial uno con el mismo nombre");
        return false;
      }
    }
    return true;
  }

  edit(obj: EspecialUno) {
    this.openModal();
    this.formEspecialUno.patchValue({
      idSprEspecialUno: obj.idSprEspecialUno,
      spr_idSprEspecialUno: obj.spr_idSprEspecialUno,
      nombre: obj.nombre,
      descripcion: obj.descripcion,
      ponderacion: obj.ponderacion,
      estado: obj.estado
    });
  }

  delete(idRegister: number) {
    this.modal.open('delete-especialUno');
    this.idDeleteRegister = idRegister;
  }

  verifyEnfoque() {
    return this.objetivosService.list(`?idSprEnfoque=${this.idDeleteRegister}&delLog=N`).toPromise();

  }

  verifyPerspectiva() {
    return this.objetivosService.list(`?idSprPerspectiva=${this.idDeleteRegister}&delLog=N`).toPromise();

  }
  verifyJerarquia() {
    return this.configIndicadorService.list(`?idSprJerarquia=${this.idDeleteRegister}&delLog=N`).toPromise();

  }
  verifyTipoIndicador() {
    return this.configIndicadorService.list(`?idSprTipoIndicador=${this.idDeleteRegister}&delLog=N`).toPromise();

  }
  verifyEtapaProyecto() {
    return this.etapaService.list(`?idSprEtapaProyecto=${this.idDeleteRegister}&delLog=N`).toPromise();

  }
  verifyTipoProceso() {
    return this.procesoService.list(`?idSprTipoProceso=${this.idDeleteRegister}&delLog=N`).toPromise();

  }




  async confirmDelete() {
    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
    //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion = await this.verifyEnfoque();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
    //###################################################################################
    //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion = await this.verifyPerspectiva();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
    //###################################################################################
    //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion = await this.verifyJerarquia();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
    //###################################################################################
    //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion = await this.verifyTipoIndicador();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
    //###################################################################################
    //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion = await this.verifyEtapaProyecto();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
    //###################################################################################
    //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion = await this.verifyTipoProceso();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
    //###################################################################################
    if (confirmDelete)
     {
      if (this.getParent(this.idDeleteRegister))
      {
        this.especialUnoService.delete(
          {
            "idSprEspecialUno": this.idDeleteRegister,
            "usuario": this.currentUser.idSprUsuario,
            "delLog": "S",
            "ip": this.ipAddress
          }
        )
          .subscribe(resp => {
            this.initApp();
            this.modal.close()
            this.alert.deleteOk();
          }, (err) => {
            this.alert.deleteError();
          });
}

 }
else{
        this.alert.EliminarRegistroCatalogo();
        }
    }

  getParent(id: number) { // validacion para que no se pueda eliminar un padre con hijos

    for (let elemento of this.dataApp) {

      if (elemento.spr_idSprEspecialUno == id) {
        this.alert.EliminarRegistroCatalogo()
        this.modal.closeId('delete-especialUno')
        return false
      }
    }
    return true
  }


  listDataApp() {
    this.especialUnoService.list()
      .subscribe((resp) => {
        this.dataApp = resp;
        this.getDataDependiente(this.selectedOptionRecursivo);
        this.dataApp = resp;

      });
    return true;
  }

  cargarCatalogoDependiente(a: any) {
    this.selectedOptionRecursivo = a.value
    this.nombrePadre = a[a['options'].selectedIndex].text
    if (this.selectedOptionRecursivo > 0) {
      this.getDataDependiente(this.selectedOptionRecursivo);
    } else {
      this.dataViewTable = this.fathers;
    }
  }

  getDataDependiente(spr_idSprEspecialUno: any = null) {
    let stateOptionTipo = false;
    let father = "N/A";
    let dataAllProcesar = this.dataApp;
    let dependientes: any = [];
    dataAllProcesar.forEach((row: any) => {
      if (!stateOptionTipo && spr_idSprEspecialUno != null) {
        father = (row.idSprEspecialUno == spr_idSprEspecialUno) ? row.nombre : "";
        if (father != "") { stateOptionTipo = true; }
      }
      if (row.spr_idSprEspecialUno == spr_idSprEspecialUno) {
        dependientes.push(
          {
            idSprEspecialUno: row.idSprEspecialUno,
            nombre: row.nombre,
            descripcion: row.descripcion,
            ponderacion: row.ponderacion,
            spr_idSprEspecialUno: row.spr_idSprEspecialUno,
            estado: row.estado,
            tipo: father,
          });
      }
    });
    if (spr_idSprEspecialUno == null || spr_idSprEspecialUno == 0) {
      this.dataViewTable = dependientes
      this.fathers = dependientes
    } else {
      this.dataViewTable = dependientes
    }
  }

  openModal() {
    this.onResetForm();
    this.modal.open(this.nameModal);
    if (this.selectedOptionRecursivo == 0 || this.selectedOptionRecursivo == null) {
      this.nombrePadre = null
    }
    this.formEspecialUno.patchValue({
      spr_idSprEspecialUno: this.selectedOptionRecursivo,
      nombrePadre: this.nombrePadre,
      ponderacion: ""

    });

  }

  onResetForm() {
    this.submitted = false;
    this.formEspecialUno.reset();
  }
}
